import CardEventoHistory from './CardEventoHistory'

export default CardEventoHistory